module.exports = __webpack_public_path__ + "img/chongtui.265231bf.png";